import { AppThunk } from '../../../../../store/types';
import { ContentLibActions } from '../../../../../store/contentLib/actions';
import { Navigator } from '../../../../../effects/navigator';

export class ContentLibCategoryListEvents {

  public static onCategorySelect(id: number): AppThunk {
    return async (
      dispatch,
      getState
    ) => {
      dispatch(ContentLibActions.setSelectedCategoryId(id));
      Navigator.navigateContentLib();
    }
  }

}
